/**
 *  Copyright AlpineReplay Inc, 2021. All rights reserved.
 *  Authors: Brian Bal, Ivan Ryabov, Leonid Khramov
 */
import { connect } from "react-redux"
import React from "react"
import { withRouter } from "react-router"

import "./TeamsContainer.css"
import * as act from "../actions/staff"
import ContainerWithMenu from "./ContainerWithMenu"
import { ModalPage } from "../../../modules/Navigation"
import { pageTitle } from "trux"

import {
    Element,
    Card,
    Label,
    Button,
    Row,
    Column,
    Input,
    Modal,
    CloseButton,
    ContentSection,
    StepController,
    Step,
} from "trux"

import { webApi } from "../../../lib/WebApi"

const TEST_MODE = false

class Teams extends ContainerWithMenu {
    constructor(props) {
        super(props, "Teams", "menu_teams")

        this.state = {
            activeMore: false,
            openMore: false,
            isAddOpen: false,
            addStep: "collect-payment",
            cardExpMonth: "",
            cardExpYear: "",
            billingInfo: {
                loaded: false,
                card: {
                    brand: "--",
                    last4: "----",
                },
                active_teams: 0,
                can_add_team: false,
                can_purchase_team: false,
                max_roster_addons: 0,
                max_teams: 0,
                subs: 0,
                teams_purchased: 0,
            },
            purchaseError: null,
            expMonthError: null,
            expYearError: null,
        }

        this.onBack = this.onBack.bind(this)
        this.handlePurchase = this.handlePurchase.bind(this)
        this.closeAdd = this.closeAdd.bind(this)
        this.contactSupport = this.contactSupport.bind(this)
        this.makePurchase = this.makePurchase.bind(this)
    }

    componentWillReceiveProps(nextProps) {
        if (
            nextProps.divisionId !== this.props.divisionId ||
            nextProps.loggedIn !== this.props.loggedIn
        ) {
            this.props.loadTeamsByDivision(nextProps.divisionId)
        }
    }

    componentWillMount() {
        this.props.loadTeamsByDivision(this.props.divisionId)
        this.loadBillingInfo(this.props.divisionId)
    }

    componentDidMount() {
        pageTitle(this.getTitle(), "Team - Roster List")
        console.log("loadStaff", this.props.divisionId)
        this.props.loadStaff(this.props.divisionId)
    }

    getTitle() {
        return "Teams"
    }

    isFromIOS() {
        return this.props.via === "iosapp"
    }

    onBack() {
        this.props.history.replace(
            `/${this.props.match.params.team}/settings/division/${this.props.match.params.division_id}`
        )
        //this.props.history.go(-1)
    }

    loadBillingInfo(divisionId) {
        let url =
            `https://lapi.traceup.com/tracebot-${process.env.REACT_APP_TRACE_ENV}/tracebot/billing?division_id=` +
            divisionId
        if (TEST_MODE) {
            url =
                "http://localhost:3000/dev/tracebot/billing?division_id=" +
                divisionId
        }

        let headers = {
            "x-api-key": TEST_MODE
                ? "d41d8cd98f00b204e9800998ecf8427e"
                : "1P9LsTEUVBHv3SbYK1kzSDqGJq9QtVWRp8E6LTOYSHJrsTGFyMGn6eWIj92i6im",
        }

        fetch(url, {
            headers: headers,
            method: "GET",
            mode: "cors",
        })
            .then((resp) => {
                return resp.json()
            })
            .then((json) => {
                console.log("loadBillingInfo", json)
                if (json) {
                    json.data.loaded = true
                    this.setState({ billingInfo: json.data })
                }
            })
    }

    addTeamPressed() {
        if (!TEST_MODE) {
            let channel = "CJDN93L7J" // alerts
            let icon = ":moneybag:"
            webApi.postSlack(
                `ROSTER ADD-ON: ${this.props.user.first_name} ${this.props.user.last_name}<${this.props.user.email}> pressed add free team for division ${this.props.division.title} #${this.props.division.division_id}`,
                icon,
                null,
                channel
            )
        }
    }

    async handlePurchase(e) {
        if (e) {
            e.preventDefault()
        }
        this.setState({ isAddOpen: true, addStep: "collect-payment" })

        if (!TEST_MODE) {
            let channel = "CJDN93L7J" // alerts
            let icon = ":moneybag:"
            webApi.postSlack(
                `ROSTER ADD-ON: ${this.props.user.first_name} ${this.props.user.last_name}<${this.props.user.email}> pressed buy team for division ${this.props.division.title} #${this.props.division.division_id}`,
                icon,
                null,
                channel
            )
        }
    }

    async makePurchase(e) {
        if (e) {
            e.preventDefault()
        }
        this.setState({
            purchaseError: null,
            expMonthError: null,
            expYearError: null,
            addStep: "making-purchase",
        })

        let url =
            `https://lapi.traceup.com/tracebot-${process.env.REACT_APP_TRACE_ENV}/tracebot/billing/purchase/roster-addon`
        if (TEST_MODE) {
            url =
                "http://localhost:3000/dev/tracebot/billing/purchase/roster-addon"
        }

        let headers = {
            "x-api-key": TEST_MODE
                ? "d41d8cd98f00b204e9800998ecf8427e"
                : "1P9LsTEUVBHv3SbYK1kzSDqGJq9QtVWRp8E6LTOYSHJrsTGFyMGn6eWIj92i6im",
            Accept: "*/*",
            "Content-Type": "application/json",
        }

        let params = {
            division_id: this.props.divisionId,
            card_exp_month: this.state.cardExpMonth,
            card_exp_year: this.state.cardExpYear,
        }

        try {
            let resp = await fetch(url, {
                body: JSON.stringify(params),
                headers: headers,
                method: "POST",
                mode: "cors",
            })
            let json = await resp.json()
            console.log("make purchase json", json)

            if (json.data && json.data.success) {
                json.data.loaded = true
                this.setState({
                    isAddOpen: true,
                    addStep: "purchase-success",
                    billingInfo: json.data,
                })
            } else {
                let expMsg =
                    "Expiration date did not match the credit card on file."
                this.setState({
                    purchaseError: json.data.error,
                    expMonthError: json.data.error === expMsg ? " " : null,
                    expYearError: json.data.error === expMsg ? " " : null,
                    addStep: "collect-payment",
                })
            }
        } catch (err) {
            this.setState({
                purchaseError: "Payment request failed please try again",
                expMonthError: null,
                expYearError: null,
                addStep: "collect-payment",
            })
        }
    }

    contactSupport(e) {
        if (e) {
            e.preventDefault()
        }
        this.setState({ isAddOpen: true, addStep: "help" })

        if (!TEST_MODE) {
            let channel = "CFF2U49T8" // customer success
            let icon = ":moneybag:"
            webApi.postSlack(
                `ROSTER ADD-ON: ${this.props.user.first_name} ${this.props.user.last_name}<${this.props.user.email}> needs help to purchase an extra team for division ${this.props.division.title} #${this.props.division.division_id}`,
                icon,
                null,
                channel
            )
        }
    }

    closeAdd() {
        this.setState({ isAddOpen: false })
    }

    activeTeamList() {
        let allTeams = this.props.teams ? this.props.teams : []
        let teams = []
        let showMore = !this.state.activeMore && allTeams.length > 5
        let showLess = this.state.activeMore && allTeams.length > 5

        if (this.state.activeMore === true) {
            teams = allTeams
        } else {
            for (let i = 0; i < 5 && i < allTeams.length; i++) {
                teams.push(allTeams[i])
            }
        }

        return (
            <Element marginBottom="4">
                {teams.map((team) => {
                    return (
                        <Card
                            key={`admin-teams-${team.team_id}`}
                            marginBottom="4"
                        >
                            <Row>
                                <Label content={team.title} span="10" />
                                <Button
                                    content="Edit team"
                                    href={`/${this.props.teamName}/settings/division/${this.props.divisionId}/teams/${team.team_id}/edit`}
                                    small
                                />
                            </Row>
                        </Card>
                    )
                })}
                {showMore && (
                    <a
                        href="#more"
                        onClick={(e) => {
                            e.preventDefault()
                            this.setState({ activeMore: true })
                        }}
                    >
                        Show all {allTeams.length}
                    </a>
                )}
                {showLess && (
                    <a
                        href="#less"
                        onClick={(e) => {
                            e.preventDefault()
                            this.setState({ activeMore: false })
                        }}
                    >
                        Show less
                    </a>
                )}
            </Element>
        )
    }

    renderContent() {
        let price = this.state.billingInfo.price
        let numFreeLeft = this.state.billingInfo.team_slots
        let hasFreeTeam = this.state.billingInfo.can_add_team
        let canPurchaseTeam = this.state.billingInfo.can_purchase_team
        let billingLoaded = this.state.billingInfo.loaded
        let isTraceFamily = this.props.division.type === 'family';
        let card = this.state.billingInfo.card
            ? this.state.billingInfo.card
            : { brand: "--", last4: "----" }
        if (!this.props.user || !this.props.owner) {
            billingLoaded = false
        }

        let dialogMessage = "..."
        if (this.props.user && this.props.owner) {
            if (this.props.user_id === this.props.owner_id) {
                dialogMessage = (
                    <>
                        Someone from Trace will be reaching out
                        <br />
                        to you shortly to help add a team
                        <br />
                        to your subscription plan.
                    </>
                )
            } else {
                dialogMessage = (
                    <>
                        Someone from Trace will be reaching out
                        <br />
                        to the account owner {this.props.owner.first_name}{" "}
                        {this.props.owner.last_name} shortly to help add a team
                        <br />
                        to your subscription plan.
                    </>
                )
            }
        }
        return (
            <ModalPage
                title="Teams"
                onBackPressed={this.onBack}
                onClosePressed={this.onClose}
                teamId={this.props.match.params.team}
                hideHeader={this.isFromIOS()}
            >
                {this.props.division.division_id && (
                    <div className="Teams modal-container">
                        <Row marginBottom="4">
                            <Label
                                type={Label.Type.Heading3}
                                content={`Teams (${this.props.teams.length})`}
                            />
                        </Row>

                        {this.activeTeamList()}

                        {hasFreeTeam && (
                            <Column center>
                                <Label
                                    type={Label.Type.Heading4}
                                    marginBottom="4"
                                    content={`You have ${numFreeLeft} pre-paid team${
                                        numFreeLeft > 1 ? "s" : ""
                                    }`}
                                />
                                <Button
                                    primary
                                    content="Add a team - FREE"
                                    href={`/#/${this.props.teamName}/settings/division/${this.props.divisionId}/teams/add`}
                                    onClick={(e) => this.addTeamPressed()}
                                    trkAction="Roster Add-on Add Free Pressed"
                                />
                            </Column>
                        )}

                        {canPurchaseTeam && (
                            <Column center>
                                <Label
                                    type={Label.Type.Heading4}
                                    marginBottom="4"
                                    content={"Need more teams?"}
                                />
                                <Button
                                    primary
                                    content={`Buy a team - $${price}`}
                                    onClick={this.handlePurchase}
                                    trkAction="Roster Add-on Buy Pressed"
                                />
                            </Column>
                        )}

                        {billingLoaded &&
                            !hasFreeTeam &&
                            !canPurchaseTeam &&
                            !isTraceFamily && (
                                <Column center>
                                    <Label
                                        type={Label.Type.Heading4}
                                        marginBottom="4"
                                        content={"Need more teams?"}
                                    />
                                    <Button
                                        primary
                                        content="Contact us"
                                        onClick={this.contactSupport}
                                        trkAction="Roster Add-on Contact Us Pressed"
                                    />
                                </Column>
                            )}

                        {isTraceFamily && !hasFreeTeam && (
                            <Column center>
                                <Label
                                    type={Label.Type.Heading4}
                                    marginBottom="4"
                                    content={"Need more teams?"}
                                />
                                <Button
                                    primary
                                    content="Create New Team"
                                    href={`/${this.props.teamName}/settings/division/${this.props.divisionId}/teams/add`}
                                    onClick={(e) => this.addTeamPressed()}
                                    trkAction="Roster Add-on Family Add Pressed"
                                />
                            </Column>
                        )}

                        <Modal open={this.state.isAddOpen}>
                            <StepController step={this.state.addStep}>
                                <Step name="collect-payment">
                                    <CloseButton onClick={this.closeAdd} />
                                    <ContentSection style={{ maxWidth: 500 }}>
                                        <Label
                                            type={Label.Type.Heading4}
                                            content="Buy a team"
                                            marginBottom="4"
                                            center
                                        />
                                        <Label
                                            content="Verify the card on file to purchase another team."
                                            marginBottom="8"
                                            center
                                        />
                                        <Row>
                                            <Input
                                                label="Card"
                                                type={Input.Type.Text}
                                                value={`${card.brand} **** **** **** ${card.last4}`}
                                                disabled
                                                span="6"
                                            />
                                        </Row>
                                        <Row>
                                            <Input
                                                label="Exp&nbsp;month"
                                                type={Input.Type.Text}
                                                placeholder="MM"
                                                marginRight="4"
                                                span="3"
                                                value={this.state.cardExpMonth}
                                                error={this.state.expMonthError}
                                                onChange={(val) => {
                                                    if (val.length > 2) {
                                                        val = val.substring(
                                                            0,
                                                            2
                                                        )
                                                    }
                                                    this.setState({
                                                        cardExpMonth: val,
                                                    })
                                                }}
                                            />
                                            <Input
                                                label="Exp&nbsp;year"
                                                type={Input.Type.Text}
                                                placeholder="YYYY"
                                                span="3"
                                                value={this.state.cardExpYear}
                                                error={this.state.expYearError}
                                                onChange={(val) => {
                                                    if (val.length > 4) {
                                                        val = val.substring(
                                                            0,
                                                            4
                                                        )
                                                    }
                                                    this.setState({
                                                        cardExpYear: val,
                                                    })
                                                }}
                                            />
                                        </Row>
                                        {this.state.purchaseError && (
                                            <div className="purchase-error">
                                                <Label
                                                    className="Label inline"
                                                    bold
                                                    content="Error:&nbsp;"
                                                />
                                                <Label
                                                    className="Label inline"
                                                    content={
                                                        this.state.purchaseError
                                                            .message
                                                    }
                                                />
                                            </div>
                                        )}
                                        <Row
                                            center
                                            marginTop="4"
                                            marginBottom="4"
                                        >
                                            <Button
                                                primary
                                                onClick={this.makePurchase}
                                                content={`Pay $${price}`}
                                                trkAction="Roster Add-on Pay Pressed"
                                            />
                                        </Row>
                                    </ContentSection>
                                </Step>
                                <Step name="making-purchase">
                                    <ContentSection>
                                        <Label
                                            type={Label.Type.Heading4}
                                            content="Processing Purchase"
                                            marginBottom="4"
                                            center
                                        />
                                        <Label
                                            content="Just a second ..."
                                            marginBottom="4"
                                            center
                                        />
                                    </ContentSection>
                                </Step>
                                <Step name="purchase-success">
                                    <ContentSection>
                                        <Column center marginBottom="4">
                                            <h3 className="center mb-4">
                                                <span
                                                    role="img"
                                                    aria-label="thumbs up"
                                                >
                                                    👍
                                                </span>
                                            </h3>
                                            <Label
                                                type={Label.Type.Heading4}
                                                content="Purchase confirmed!"
                                                marginBottom="8"
                                                center
                                            />
                                            <Button
                                                primary
                                                content="Create my team"
                                                onClick={(e) => {
                                                    this.props.history.push(
                                                        `/${this.props.teamName}/settings/division/${this.props.divisionId}/teams/add`
                                                    )
                                                }}
                                                trkAction="Roster Add-on Create Purchased"
                                            />
                                        </Column>
                                    </ContentSection>
                                </Step>
                                <Step name="help">
                                    <CloseButton onClick={this.closeAdd} />
                                    <ContentSection>
                                        <Label
                                            type={Label.Type.Heading4}
                                            content="Help is on the way"
                                            marginBottom="4"
                                            center
                                        />
                                        <Label
                                            content={dialogMessage}
                                            marginBottom="4"
                                            center
                                        />
                                    </ContentSection>
                                </Step>
                            </StepController>
                        </Modal>
                    </div>
                )}
            </ModalPage>
        )
    }
}

const mapStateToProps = (state, props) => {
    const via = state.via
    const loadTeamsInProgress = !state.divisions.complete
    const loadTeamsError = state.divisions.error
    let teams = []
    const divisionId = parseInt(props.match.params.division_id, 10)
    const teamName = props.match.params.team
    let divisions = []
    const loggedIn = state.isLoggedIn
    const now = new Date()
    let division = { title: "" }

    // divisions
    if (state.divisions.value) {
        divisions = state.divisions.value.filter(
            (d) => d.division_id > 0
        )
    }

    // division and teams
    for (let div of divisions) {
        if (div.division_id === divisionId) {
            division = div
            teams = div.myTeams
        }
    }

    let owner = {}
    let me = null
    if (state.user.value) {
        for (let staff of state.division_staff.value.staff) {
            if (staff.is_owner && staff.user_id === state.user.value.user_id) {
                me = staff
            }
        }
        if (me) {
            owner = me
        } else {
            for (let staff of state.division_staff.value.staff) {
                if (staff.is_owner) {
                    owner = staff
                }
            }
        }
    }

    return {
        via,
        teamName,
        loadTeamsInProgress,
        loadTeamsError,
        teams,
        divisionId,
        division,
        divisions,
        loggedIn,
        user: state.user.value,
        owner,
        now,
    }
}

const mapDispatchToProps = (dispatch) => {
    return {
        loadTeamsByDivision: (divisionId) => {
            //dispatch(act.loadTeamsByDivision(divisionId));
        },
        addTeam: (data, divisionId) => {
            //dispatch(act.addTeamWithDivision(data, divisionId));
        },
        changeTeam: (data, divisionId) => {},
        loadStaff: (divisionId) => {
            dispatch(act.loadStaffByDivision(divisionId))
        },
    }
}

const TeamsContainer = withRouter(
    connect(mapStateToProps, mapDispatchToProps)(Teams)
)

export default TeamsContainer
